import Pusher from 'pusher-js';
import {GetConfigFunc} from '../../../types';

let _pusher: Pusher;

export const getPusherSingleton = (
  accessToken: string,
  getConfig: GetConfigFunc,
): Pusher => {
  const config = getConfig();

  _pusher =
    _pusher ||
    new Pusher(config.Pusher.ApiKey, {
      cluster: config.Pusher.Cluster,
      authEndpoint: config.Api.BaseUrl + '/pusher/auth',
      auth: {
        params: {},
        headers: {Authorization: 'Bearer ' + accessToken},
      },
    });

  return _pusher;
};
